module.exports = __webpack_public_path__ + "/assets/img/9136b5bc4eac922b128650c605680759.png";